import React, { useState } from 'react';
// import './Header.css';
import logo from '../../assets/image/logo.png';

function Header() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header>
      <div className="header-area">
        <div className="main-header ">
          <div className="header-bottom header-sticky white-bg">
            <div className="container">
              <div className="row align-items-center">

                <div className="col-xl-2 col-lg-2">
                  <div className="logo">
                    <img src={logo} height="100" width="75" alt="Logo" />
                  </div>
                </div>

                <div className="col-xl-10 col-lg-10">
                  <div className="menu-wrapper d-flex align-items-center justify-content-end">

                    <div className="main-menu d-none d-lg-block">
                      <nav>
                        <ul id="navigation">
                          <li><a href="/">Home</a></li>
                          <li><a href="/about">About</a></li>
                          <li>
                            <a href="#">Courses</a>
                            <ul className="submenu">
                              <li><a href="/thebeginnercourse">The Beginner Course</a></li>
                              <li><a href="/theintermediatecourse">The Intermediate Course</a></li>
                              <li><a href="/theadvancedcourse">The Advance Course</a></li>
                            </ul>
                          </li>
                          <li><a href="/gallery">Gallery</a></li>
                          <li><a href="/achivement">Achivement</a></li>
                          <li><a href="/contact">Contact</a></li>
                        </ul>
                      </nav>
                    </div>

                    {/* Mobile menu toggle button - Three lines icon */}
                    <button
                      className="mobile-menu-toggle d-block d-lg-none"
                      onClick={toggleMobileMenu}
                      aria-label="Toggle mobile menu"
                    >
                      <i className="fa-solid fa-bars"></i>
                    </button>

                  </div>
                </div>

                <div className="col-12">
                  {/* Mobile menu content toggle */}
                  {isMobileMenuOpen && (
                    <div className="mobile_menu d-block d-lg-none">
                      <nav>
                        <ul>
                          <li><a href="/">Home</a></li>
                          <li><a href="/about">About</a></li>
                          <li>
                            <a href="#">Courses</a>
                            <ul>
                              <li><a href="/thebeginnercourse">The Beginner Course</a></li>
                              <li><a href="/theintermediatecourse">The Intermediate Course</a></li>
                              <li><a href="/theadvancedcourse">The Advance Course</a></li>
                            </ul>
                          </li>
                          <li><a href="/gallery">Gallery</a></li>
                          <li><a href="/achivement">Achivement</a></li>
                          <li><a href="/contact">Contact</a></li>
                        </ul>
                      </nav>
                    </div>
                  )}
                </div>

              </div>  
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
